/**
 * 认证选项常量
 */

// 国家/市场选项
export const COUNTRY_OPTIONS = [
    { value: 'US', label: '美国' },
    { value: 'CA', label: '加拿大' },
    { value: 'MX', label: '墨西哥' },
    { value: 'UK', label: '英国' },
    { value: 'DE', label: '德国' },
    { value: 'FR', label: '法国' },
    { value: 'IT', label: '意大利' },
    { value: 'ES', label: '西班牙' },
    { value: 'NL', label: '荷兰' },
    { value: 'SE', label: '瑞典' },
    { value: 'PL', label: '波兰' },
    { value: 'JP', label: '日本' },
    { value: 'AU', label: '澳大利亚' },
    { value: 'SG', label: '新加坡' },
    { value: 'AE', label: '阿联酋' },
    { value: 'SA', label: '沙特' },
    { value: 'IN', label: '印度' },
    { value: 'BR', label: '巴西' },
];

// 认证类型选项（分组）
export const CERTIFICATION_TYPE_OPTIONS = [
    {
        label: '美国/北美',
        options: [
            { value: 'FCC', label: 'FCC - 电子产品认证' },
            { value: 'UL', label: 'UL - 安全认证' },
            { value: 'ETL', label: 'ETL - 安全认证' },
            { value: 'FDA', label: 'FDA - 食品药品监管' },
            { value: 'DOT', label: 'DOT - 交通部认证' },
            { value: 'EPA', label: 'EPA - 环保署认证' },
            { value: 'CPSC', label: 'CPSC - 消费品安全' },
            { value: 'ASTM', label: 'ASTM - 材料测试标准' },
            { value: 'California_Prop65', label: 'California Prop 65' },
            { value: 'CEC', label: 'CEC - 能效认证' },
        ],
    },
    {
        label: '欧盟/英国',
        options: [
            { value: 'CE', label: 'CE - 欧盟强制认证' },
            { value: 'RoHS', label: 'RoHS - 有害物质限制' },
            { value: 'REACH', label: 'REACH - 化学品注册' },
            { value: 'WEEE', label: 'WEEE - 电子废弃物' },
            { value: 'ERP', label: 'ErP - 能源相关产品' },
            { value: 'GS', label: 'GS - 德国安全认证' },
            { value: 'UKCA', label: 'UKCA - 英国合格认证' },
        ],
    },
    {
        label: '日本',
        options: [
            { value: 'PSE', label: 'PSE - 电气用品安全' },
            { value: 'TELEC', label: 'TELEC - 无线电认证' },
            { value: 'VCCI', label: 'VCCI - 电磁兼容' },
            { value: 'JIS', label: 'JIS - 日本工业标准' },
        ],
    },
    {
        label: '澳洲/加拿大',
        options: [
            { value: 'RCM', label: 'RCM - 监管合规标志' },
            { value: 'C-Tick', label: 'C-Tick - 电磁兼容' },
            { value: 'SAA', label: 'SAA - 澳洲标准认证' },
            { value: 'IC', label: 'IC - 工业加拿大认证' },
            { value: 'CSA', label: 'CSA - 加拿大标准协会' },
        ],
    },
    {
        label: '其他',
        options: [
            { value: 'CCC', label: 'CCC - 中国强制认证' },
            { value: 'CQC', label: 'CQC - 中国质量认证' },
            { value: 'ISO', label: 'ISO - 国际标准化组织' },
            { value: 'IEC', label: 'IEC - 国际电工委员会' },
            { value: 'CB', label: 'CB - 国际电工产品认证' },
            { value: 'Other', label: '其他认证' },
        ],
    },
];
